export var RegionCode;
(function (RegionCode) {
    RegionCode[RegionCode["INSIDE"] = 0] = "INSIDE";
    RegionCode[RegionCode["LEFT"] = 1] = "LEFT";
    RegionCode[RegionCode["RIGHT"] = 2] = "RIGHT";
    RegionCode[RegionCode["BOTTOM"] = 4] = "BOTTOM";
    RegionCode[RegionCode["TOP"] = 8] = "TOP";
})(RegionCode || (RegionCode = {}));
export function isCartesian(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.x !== undefined && b.y !== undefined;
}
export function isCartesian3(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.x !== undefined && b.y !== undefined && b.z !== undefined;
}
export function isCartesianArray(b) {
    return Array.isArray(b) && b.every(isCartesian);
}
export function isArrayOfCartesianArray(input) {
    if (!Array.isArray(input)) {
        return false;
    }
    return input.every(isCartesianArray);
}
export function isCartesian4(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.x !== undefined && b.y !== undefined && b.z !== undefined && b.w !== undefined;
}
export var Side;
(function (Side) {
    Side[Side["left"] = 0] = "left";
    Side[Side["top"] = 1] = "top";
    Side[Side["right"] = 2] = "right";
    Side[Side["bottom"] = 3] = "bottom";
})(Side || (Side = {}));
export function IsSize(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return b.height !== undefined && b.width !== undefined;
}
export function IsSize3(size) {
    return IsSize(size) && size.depth !== undefined;
}
export function IsBounds(b) {
    if (typeof b !== "object" || b === null)
        return false;
    return (b.xmin !== undefined &&
        b.ymin !== undefined &&
        b.zmin !== undefined &&
        b.xmax !== undefined &&
        b.ymax !== undefined &&
        b.zmax !== undefined);
}
//# sourceMappingURL=geometry.interfaces.js.map